import { render } from "./StoriesModal.vue?vue&type=template&id=64ecb574&scoped=true"
import script from "./StoriesModal.vue?vue&type=script&lang=js"
export * from "./StoriesModal.vue?vue&type=script&lang=js"

import "./StoriesModal.vue?vue&type=style&index=0&id=64ecb574&lang=scss&scoped=true"
import "./StoriesModal.vue?vue&type=style&index=1&id=64ecb574&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ecb574"]])

export default __exports__